import { css, styled } from '@mui/material';
import { device } from 'src/constants/mediaQueries';

export const StyledCancelButtonContainer = styled('div')`
  text-align: left;
`;

export const ProcessingFileContent = styled('div')`
  height: 100%;
  display: flex;
  flex-direction: row;
  padding: ${({ theme }) => theme.spacing(4)};
  text-align: center;
  @media only screen and ${device.largeLaptopOrSmallDesktop} {
    gap: ${({ theme }) => theme.spacing(3)};
  }
  @media only screen and ${device.mobileOrTablet} {
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(1)};
  }
  align-items: center;
  justify-content: center;
  ${({ theme }) => css`
    background-color: ${theme.palette.grey[100]};
  `}
`;

export const FooterContainer = styled('section')`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 1.5rem 0;
  ${({ theme }) => css`
    background-color: ${theme.palette.background.paper};
  `}
`;
